import {
	changelogPortalIds,
	MAIN_PORTAL_INSTANCE_ID,
} from "@productlane/lib/src/portal-instance"

export { changelogPortalIds }

/** Adds or removes one portal, keeping the workspace's own portal order. */
export function togglePortalId(
	current: readonly string[],
	portalId: string,
	orderedPortalIds: readonly string[],
): string[] {
	const next = new Set(current)
	if (next.has(portalId)) next.delete(portalId)
	else next.add(portalId)
	return orderedPortalIds.filter((id) => next.has(id))
}

/** Whether an entry reaches a given portal, with the main portal as null. */
export function isOnPortal(
	changelog: {
		portalInstanceId?: string | null
		portalInstanceIds?: readonly string[] | null
	},
	portalInstanceId: string | null,
): boolean {
	const target = portalInstanceId ?? MAIN_PORTAL_INSTANCE_ID
	return changelogPortalIds(changelog).includes(target)
}

/** Trigger label: every portal, one named portal, a count, or none. */
export function portalSelectionLabel(
	selected: readonly string[],
	allPortals: readonly { id: string; name: string }[],
): string {
	if (selected.length === 0) return "No portals"
	if (allPortals.length > 0 && selected.length === allPortals.length) {
		return "All portals"
	}
	if (selected.length === 1) {
		const only = allPortals.find((portal) => portal.id === selected[0])
		return only?.name ?? "1 portal"
	}
	return `${selected.length} portals`
}

/**
 * The portal an entry is presented as belonging to, for a link or a sender
 * name. Prefers a named portal over the main one, since that is the branding a
 * reader expects. Returns null for the main portal.
 */
export function primaryPortalInstanceId(changelog: {
	portalInstanceId?: string | null
	portalInstanceIds?: readonly string[] | null
}): string | null {
	const named = changelogPortalIds(changelog).find(
		(id) => id !== MAIN_PORTAL_INSTANCE_ID,
	)
	return named ?? null
}
